// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".linesImg {\n    width: 27px;\n    text-align: center;\n}", "",{"version":3,"sources":["webpack://./resources/css/components/_img.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".linesImg {\n    width: 27px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
